export const DEFAULT_DIALOG_CONFIG = {
  type: "is-danger",
  hasIcon: true,
  icon: "close-octagon",
  title: "Oops!"
};
